'use strict';

module.exports = [require('./setCartesian'), require('./setDifference'), require('./setDistinct'), require('./setIntersect'), require('./setIsSubset'), require('./setMultiplicity'), require('./setPowerset'), require('./setSize'), require('./setSymDifference'), require('./setUnion')];


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/function/set/index.js
// module id = 1109
// module chunks = 0